export default __webpack_public_path__ + "build/1c93e6b2419a1aea38f766031d4400ba.svg";